import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@/shared/services/api/auth.service';
import { map } from 'rxjs';
import { UserService } from '@/shared/services/api/user.service';

export const roleGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const userService = inject(UserService);
    const router = inject(Router);
    const allowed = (route.data?.['roles'] as string[] | undefined) ?? [];
    const routeId = route.paramMap.get('id');

    // Si se recarga la página, cargamos de nuevo el usuario para comprobar su rol.
    if (!authService.currentUser()) {
        return userService.loadUser().pipe(
            map(() => {
                const user = authService.currentUser();
                const role = authService.getPrimaryRole(user?.roles);

                //En caso de que el cliente navegue a la ficha de otro cliente
                if (role === 'client' && route.routeConfig?.path === 'clients/:id') {
                    if (routeId !== String(user?.client?.id)) {
                        router.navigate(['/forbidden']);
                        return false;
                    }
                }

                //En caso de que el driver navegue a la ficha de otro cliente
                if (role === 'driver' && route.routeConfig?.path === 'drivers/:id') {
                    if (routeId !== String(user?.driver?.id)) {
                        router.navigate(['/forbidden']);
                        return false;
                    }
                }

                if (!allowed.length || (role && allowed.includes(role))) {
                    return true;
                }

                router.navigate(['/forbidden']);
                return false;
            })
        );
    }

    const user = authService.currentUser();
    const role = authService.getPrimaryRole(user?.roles);
    //En caso de que el cliente navegue a la ficha de otro cliente
    if (role === 'client' && route.routeConfig?.path === 'clients/:id') {
        if (routeId !== String(user?.client?.id)) {
            router.navigate(['/forbidden']);
            return false;
        }
    }

    //En caso de que el driver navegue a la ficha de otro cliente
    if (role === 'driver' && route.routeConfig?.path === 'drivers/:id') {
        if (routeId !== String(user?.driver?.id)) {
            router.navigate(['/forbidden']);
            return false;
        }
    }

    if (!allowed.length || (role && allowed.includes(role))) {
        return true;
    }

    router.navigate(['/forbidden']);
    return false;
};
